import BlockchainClient from 'bryt-sdk';
import { privateKey, rpcUrl } from '../app.config';

export const bryt = new BlockchainClient(rpcUrl, privateKey);
